const locale = {
  dashboard: 'Panel de control',
  home_dashboard: 'Página de inicio',
  dashboard_news: 'Noticias',
  dashboard_slides: 'Banderas',
  dashboard_notifications: 'Notificaciones',
  dashboard_account: 'Mi cuenta',
  dashboard_team: 'Mi equipo',
  dashboard_mini_site: 'Mini-sitio',
  dashboard_loyalty_campaign: 'Campaña de fidelización',
  product_order: 'Pedir productos',
  digital_pub: 'Publicidad digital',
  training: 'Formación',
  dashboard_content_library: 'Biblioteca de contenido',
  hairdressers_network: 'Red de peluquerías',
  hairdressers: 'Peluquerías',
  hairdressers_list: 'Lista de peluquerías',
  hairdresser_add: 'Agregar una peluquería',
  link_hairdresser_supervisor: 'Enlace de peluquería/supervisor',
  services: 'Servicios',
  services_list: 'Lista de servicios',
  services_add: 'Agregar un servicio',
  services_link: 'Asociar un servicio',
  national_operations: 'Operaciones nacionales',
  national_operation: "'Operación nacional",
  national_operations_list: 'Lista de operaciones nacionales',
  national_operations_add: 'Agregar una operación doméstica',
  national_operations_participate: 'Asociar una operación doméstica',
  prices: 'Prestaciones y tarifas',
  jobs: 'Ofertas de trabajo',
  jobs_list: 'Lista de ofertas de trabajo',
  jobs_add: 'Agregar una oferta de trabajo',
  customer_relationship: 'Relación cliente',
  contacts: 'Contactos',
  contacts_list: 'Lista de contactos',
  contacts_import: 'Importar contactos',
  origin_code_list: 'Lista de códigos de origen',
  origin_code_add: 'Agregar un código de origen',
  feedbacks: 'Comentarios de los clientes',
  feedbacks_list: 'Lista de comentarios de los clientes',
  feedbacks_response_model: 'Plantilla de respuesta',
  feedbacks_receiver: 'Destinatarios de las comentarios',
  access: 'Accesos',
  collaborators: 'Lista de colaboradores',
  collaborators_add: 'Agregar un colaborador',
  users_and_groups: 'Usuarios y grupos',
  users_list: 'Lista de usuarios',
  users_add: 'Agregar un usuario',
  groups_list: 'Lista de grupos',
  groups_add: 'Agregar un grupo',
  resources: 'Recursos',
  press: 'Zona de prensa',
  press_admin: 'Administración de la prensa',
  documentation: 'Documentación',
  documentation_admin: 'Administración de la documentación',
  intranet_doc: 'Espacio documental',
  mass_administration: 'Gestión de masas',
  minisite: 'Minisitios',
  minisiteList: 'Actualizaciones de monitoreo',
  minisiteMessageList: 'Lista de saludos',
  minisiteTagList: 'Lista de metaetiquetas',
  minisiteMassiveImport: 'Administración masiva',
  access_to: 'Acceso a la',
  payment_x3: 'Pago en 3x',
  prices_list: 'Lista de servicios y tarifas',
  legals_list: 'Lista de avisos legales',
  legals_add: 'Agregar un aviso legal',
  legals_participate: 'Asociar un aviso legal',
  mass_administration_price_list: 'Servicios y Precios',
  mass_administration_businessHours_list: 'Horario comercial',
  mass_administration_message_list: 'Mensajes de Bienvenida',
  mass_administration_tag_list: 'Etiquetas Meta',
  mass_administration_picture_list: 'Fotos',
  terms_nav: 'Términos y condiciones',
  TOU: 'CGU',
  privacy_policy: 'Política de privacidad',
  cookies_policy: 'Política de gestión de cookies',
  faq: 'Preguntas Frecuentes'
};

export default locale;
